import { render, staticRenderFns } from "./Anli.vue?vue&type=template&id=8fe19628&scoped=true&"
import script from "./Anli.vue?vue&type=script&lang=js&"
export * from "./Anli.vue?vue&type=script&lang=js&"
import style0 from "./Anli.vue?vue&type=style&index=0&id=8fe19628&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fe19628",
  null
  
)

export default component.exports